export const codeSnippet = {
  code1: `import { useState, useEffect, useRef  } from "react"
function App() {
	const [name, setName] = useState("")
	const renderCount = useRef(0)
	
	useEffect(() => {
		renderCount.current = renderCount.current + 1
	})
	return (
	<div className="App">
		<input ref={renderCount} type="text" name="name" onChange={e=>setName(e.target.value)} />
		<div> Name is: {name} </div>
		<div> I rendred {renderCount.current} times </div>
	</div>
	)
}`,
  code2: `<button onClick={()=> {
import ("../sum.js".then(module => {
	alert(module.sum(2,2))
	})
}}

export function sum(a, b){
	return a + b;
}`,
	code3: `import React, { Suspense } from 'react';
const OtherComponent = React.lazy(() => import('./OtherComponent'));
function MyComponent() {
	return (
		<Suspense fallback={<div>Loading...</div>}>
			<OtherComponent />
		</Suspense>
	);
}`,
	code4: `import Loadable from 'react-loadable';
const OtherComponent = Loadable({
	loader: () => import('./OtherComponent'),
	loading: () => <div>Loading...</div>,
});

function MyComponent() {
	return <OtherComponent />;
}`,
	code5:`import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const Home = lazy(() => import('./routes/Home'));
const About = lazy(() => import('./routes/About'));

const App = () => (
	<Router>
		<Suspense fallback={<div>Loading...</div>}>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/about" element={<About />} />
			</Routes>
		</Suspense>
	</Router>
);`,
	code6:`// ManyComponents.js
export const MyComponent = /* ... */;
export const MyUnusedComponent = /* ... */;`,
	code7:`// MyComponent.js
export { MyComponent as default } from "./ManyComponents.js";`,
	code8:`// MyApp.js
import React, { lazy } from 'react';
const MyComponent = lazy(() => import("./MyComponent.js"));`,
	code9: `import React from 'react';

const MyComponent = ({text}) => {
	return <div>{text}</div>;
};

export default React.memo(MyComponent);`,
	code10: `import React from 'react';

const MyComponent = ({text, id}) => {
	return <div>{text}</div>;
};

const areEqual = (prevProps, nextProps) => {
	return prevProps.text === nextProps.text && prevProps.id === nextProps.id;
}

export default React.memo(MyComponent, areEqual);`,
	code11: `import React from 'react';
function withLoading(WrappedComponent) {
	return function LoadingHOC(props) {
		const { isLoading } = props;
		if (isLoading) {
			return <div>Loading...</div>;
		}
		return <WrappedComponent {...props} />;
	}
}
export default withLoading;`,
	code12: `import withLoading from './withLoading';

function MyComponent() {
	return <div>My component content</div>;
}

const MyLoadingComponent = withLoading(MyComponent);

// Now you can use MyLoadingComponent and pass the isLoading prop`,
	code13: `import React, { useEffect } from 'react';
import { useAuth } from './auth-context';

function withAuth(WrappedComponent) {
	return function AuthHOC(props) {
		const { user, logout } = useAuth();

		useEffect(() => {
			if (!user) {
				// redirect to login page
				props.history.push('/login');
			}
		}, [user, props.history]);

		return (
			<WrappedComponent user={user} logout={logout} {...props} />
		);
	}
}
export default withAuth;`,
	code14: `import withAuth from './withAuth';
function MyComponent({user, logout}) {
	return (
		<div>
			<div>Welcome, {user.name}</div>
			<button onClick={logout}>Logout</button>
		</div>
	);
}
const MyAuthComponent = withAuth(MyComponent);`,
  code15: `import React, { useState } from 'react';

function ControlledComponent() {
  const [value, setValue] = useState('');

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
    />
  );
}`,
  code16: `import React, { useRef } from 'react';

function UncontrolledComponent() {
  const inputRef = useRef();

  const handleClick = () => {
    const value = inputRef.current.value;
    console.log(value);
  };

  return (
    <div>
      <input type="text" ref={inputRef} />
      <button onClick={handleClick}>Submit</button>
    </div>
  );
}`,
	code17: `npm install node-sass react`,
	code18: `// MyComponent.scss
.container {
	background-color: blue;
	color: white;
	font-size: 16px;
}`,
	code19: `import React from 'react';
import './MyComponent.scss';

function MyComponent() {
	return <div className="container">Styled Component</div>;
}`,
	code20: `"scripts": {
	"start": "node-sass --watch src -o src"
}`,
	code21: `// _variables.scss
$primary-color: #007bff;
$font-size: 16px;`,
	code22: `// MyComponent.scss
@import './variables';

.container {
	background-color: $primary-color;
	font-size: $font-size;
}`,
	code23: `// MyComponent.scss
.container {
	background-color: blue;

	.title {
		font-size: 20px;
		color: white;
	}
}`,
	code24: `// _mixins.scss
@mixin button-styles {
	padding: 10px 20px;
	background-color: $primary-color;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}`,
	code25: `// MyComponent.scss
@import './mixins';

.my-button {
	@include button-styles;
}`,
	code26: `import React from 'react';

const App = () => {
  return React.createElement(
    'div', 
    { className: 'container' }, 
    React.createElement('h1', null, 'Hello, React without JSX!'),
    React.createElement('p', null, 'This is a paragraph.')
  );
};

export default App;`,
	code27: `npm run build 
npm login
npm publish --access public`,
	code28: `shell (host)
 ├── owns routing (/cart)
 ├── owns layout
 └── shares data via events

cart (remote)
 ├── owns /cart/*
 └── listens to shared events // Custom Event Bus (Common in MFEs)
`,
	code29: `shell/
├── public/
├── src/
│   ├── App.jsx
│   ├── index.js
│   └── eventBus.js
├── webpack.config.js
└── package.json
`,
	code30: `const HtmlWebpackPlugin = require("html-webpack-plugin");
const ModuleFederationPlugin = require("webpack/lib/container/ModuleFederationPlugin");

module.exports = {
  mode: "development",
  devServer: {
    port: 3000,
    historyApiFallback: true
  },
  output: {
    publicPath: "auto"
  },
  module: {
    rules: [
      {
        test: /\.jsx?$/,
        loader: "babel-loader",
        exclude: /node_modules/
      }
    ]
  },
  plugins: [
    new ModuleFederationPlugin({
      name: "shell",
      remotes: {
        cart: "cart@http://localhost:3001/remoteEntry.js"
      },
      shared: {
        react: { singleton: true },
        "react-dom": { singleton: true }
      }
    }),
    new HtmlWebpackPlugin({
      template: "./public/index.html"
    })
  ]
};`,
	code31: `export const emitEvent = (name, data) => {
  window.dispatchEvent(new CustomEvent(name, { detail: data }));
};`,
	code32: `import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { emitEvent } from "./eventBus";

const CartApp = React.lazy(() => import("cart/App"));

export default function App() {
  const sendUser = () => {
    emitEvent("USER_DATA", { id: 1, name: "Lindo", role: "ADMIN" });
  };

  return (
    <BrowserRouter>
      <nav>
        <Link to="/cart">Cart</Link>
        <button onClick={sendUser}>Send User</button>
      </nav>

      <React.Suspense fallback="Loading Cart...">
        <Routes>
          <Route path="/cart/*" element={<CartApp />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}`,
	code33: `import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

createRoot(document.getElementById("root")).render(<App />);`,	
	code34: `cart/
├── public/
├── src/
│   ├── App.jsx
│   ├── CartHome.jsx
│   └── index.js
├── webpack.config.js
└── package.json
`,	
	code35: `const HtmlWebpackPlugin = require("html-webpack-plugin");
const ModuleFederationPlugin = require("webpack/lib/container/ModuleFederationPlugin");

module.exports = {
  mode: "development",
  devServer: {
    port: 3001,
    historyApiFallback: true
  },
  output: {
    publicPath: "auto"
  },
  module: {
    rules: [
      {
        test: /\.jsx?$/,
        loader: "babel-loader",
        exclude: /node_modules/
      }
    ]
  },
  plugins: [
    new ModuleFederationPlugin({
      name: "cart",
      filename: "remoteEntry.js",
      exposes: {
        "./App": "./src/App"
      },
      shared: {
        react: { singleton: true },
        "react-dom": { singleton: true }
      }
    }),
    new HtmlWebpackPlugin({
      template: "./public/index.html"
    })
  ]
};`,	
	code36: `import React from "react";
import { Routes, Route } from "react-router-dom";
import CartHome from "./CartHome";

export default function CartApp() {
  return (
    <Routes>
      <Route path="/" element={<CartHome />} />
    </Routes>
  );
}
`,	
	code37: `import React, { useEffect, useState } from "react";

export default function CartHome() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const handler = e => setUser(e.detail);
    window.addEventListener("USER_DATA", handler);
    return () => window.removeEventListener("USER_DATA", handler);
  }, []);

  return (
    <div>
      <h2>🛒 Cart App</h2>
      {user ? (
        <p>User: {user.name} ({user.role})</p>
      ) : (
        <p>No user data</p>
      )}
    </div>
  );
}
`,	
	code38: `import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);`,
	code39: `// eventBus.js
export const emitEvent = (eventName, payload) => {
  window.dispatchEvent(
    new CustomEvent(eventName, { detail: payload })
  );
};`,
	code40:`import { emitEvent } from "./eventBus";

emitEvent("USER_UPDATED", {
  id: 1,
  name: "Lindo",
  role: "ADMIN"
});
`,
	code41:`import { useEffect, useState } from "react";

export default function Profile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const handler = event => setUser(event.detail);

    window.addEventListener("USER_UPDATED", handler);

    return () => {
      window.removeEventListener("USER_UPDATED", handler);
    };
  }, []);

  return <div>{user?.name}</div>;
}`,
	code42:``,
	code43:``,
	code44:``,
	code45:``,
	code46:``,



}

